export const LOGIN = 'LOGIN'
export const LOGOUT = 'LOGOUT'
export const USER_PROFILE = 'USER_PROFILE'
export const USER_CURRENT_ROLE = 'USER_CURRENT_ROLE'
